(function () {
  if (window.cmpCompareInit) return;
  window.cmpCompareInit = true;

  function smooth() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
  }

  function setup(root) {
    var scroller = root.querySelector('[data-scroller]');
    if (!scroller || scroller.dataset.cmpBound === 'true') return;
    scroller.dataset.cmpBound = 'true';

    var arrows = root.querySelector('[data-arrows]');
    var prev = root.querySelector('[data-scroll-prev]');
    var next = root.querySelector('[data-scroll-next]');

    function columns() {
      return Array.prototype.slice.call(scroller.querySelectorAll('[data-col]'));
    }

    // Absolute scroll offset of each column, measured from the scroll origin.
    function offsets() {
      var base = scroller.getBoundingClientRect().left;
      var left = scroller.scrollLeft;
      return columns().map(function (col) {
        return col.getBoundingClientRect().left - base + left;
      });
    }

    // Scroll position that puts each column exactly where the first column
    // sits at rest. Column 0 resolves to 0 — the natural layout position —
    // so paging back always lands flush instead of a few pixels off.
    function targets() {
      var list = offsets();
      if (!list.length) return [];
      var first = list[0];
      return list.map(function (offset) { return offset - first; });
    }

    function maxScroll() {
      return scroller.scrollWidth - scroller.clientWidth;
    }

    function nudge(direction) {
      var points = targets();
      if (!points.length) return;

      var current = scroller.scrollLeft;

      // Nearest column, not the last one passed — at the far end the scroll
      // position is clamped short of the final target, and treating that as
      // "still on column 2" would skip a whole column on the way back.
      var index = 0;
      var closest = Infinity;
      for (var i = 0; i < points.length; i++) {
        var distance = Math.abs(points[i] - current);
        if (distance < closest) {
          closest = distance;
          index = i;
        }
      }

      var next = Math.min(Math.max(index + direction, 0), points.length - 1);
      scroller.scrollTo({
        left: Math.min(Math.max(points[next], 0), maxScroll()),
        behavior: smooth()
      });
    }

    function update() {
      var scrollable = maxScroll() > 8;

      if (arrows) arrows.hidden = !scrollable;
      if (prev) prev.disabled = scroller.scrollLeft <= 2;
      if (next) next.disabled = scroller.scrollLeft >= maxScroll() - 2;

      scroller.classList.toggle('is-scrolled', scroller.scrollLeft > 2);
    }

    if (prev) prev.addEventListener('click', function () { nudge(-1); });
    if (next) next.addEventListener('click', function () { nudge(1); });

    scroller.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);

    scroller.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); nudge(1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); nudge(-1); }
    });

    update();
    scroller.scrollLeft = 0;
    window.setTimeout(update, 300);
  }

  function init() {
    document.querySelectorAll('[data-compare]').forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:select', init);
})();